export default defineNuxtPlugin(() => {
  document.addEventListener("click", (e) => {
    const link = (e.target as HTMLElement).closest("a");
    if (!link) return;

    const url = link.getAttribute("href");
    const spa = link.getAttribute("target") === "_spa";

    if (spa && url && !url.startsWith("http")) {
      e.preventDefault();
      useRouter().push(url);
    }
  });
});
